<div class="relative w-full h-full flex" #domEl>
  <mat-tab-group [selectedIndex]="selectedCategoryIndex()" class="relative w-full h-full">
    @for (category of project?.partCategories; track category.uuid) {
      <mat-tab class="relative w-full h-full flex" [label]="category.title">
        <mat-grid-list
          class="relative w-full h-full"
          [cols]="cols"
          [rowHeight]="rowHeight"
          [gutterSize]="gutterSize"
        >
          @for (partModel of category.partModels; track $index) {
            <mat-grid-tile class="relative" [colspan]="1">
              <div
                class="relative w-full h-full flex flex-col gap-2 p-1 lg:p-2"
                [ngClass]="{ 'animate-pulse': isLoading }"
              >
                <div
                  class="relative w-full h-full flex shadow rounded-lg overflow-hidden"
                  [ngClass]="{
                    'ring-white ring-1': partModel.isSelected,
                    'ring-none': !partModel.isSelected,
                  }"
                >
                  <div
                    class="relative w-1/3 h-full bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden bg-[#1C1B1E]"
                    style="background-size: cover; background-position: center"
                    [ngStyle]="{ backgroundImage: 'url(' + partModel.thumbnail + ')' }"
                    [title]="partModel.title"
                  >
                    @if (partModel.sound) {
                      <button
                        class="absolute flex justify-center items-center top-1.5 right-1.5 w-5 lg:w-8 h-5 lg:h-8 border-2 lg:border-[3px] border-black/40 bg-white/40 group hover:border-black hover:bg-white rounded-full"
                        (click)="onClickSoundBtn(partModel.sound)"
                      >
                        <div
                          class="text-xs lg:text-lg text-black/40 group-hover:text-black flex justify-center items-center"
                        >
                          <mat-icon [inline]="true">volume_up</mat-icon>
                        </div>
                      </button>
                    }
                  </div>
                  <div
                    class="px-3 py-1.5 flex flex-col gap-1 justify-between leading-normal w-1/2 h-full bg-[#E3E4E1] dark:bg-[#1C1B1E]"
                  >
                    <div class="relative flex-none flex flex-col">
                      <a
                        class="hover:underline"
                        [href]="
                          environment.saleor.storeFront +
                          '/product-details/' +
                          partModel.marketplaceProduct?.channel +
                          '/' +
                          partModel.marketplaceProduct?.slug
                        "
                        target="_blank"
                      >
                        <p
                          class="text-black dark:text-white w-full font-bold text-sm lg:text-lg text-start p-0 m-0 overflow-hidden text-nowrap text-ellipsis"
                        >
                          {{ partModel.title }}
                        </p>
                      </a>
                      @if (partModel.marketplaceProduct?.price) {
                        <p
                          class="text-[#807F7B] dark:text-[#7F8084] text-xs lg:text-base text-start"
                        >
                          {{
                            (threeGraphqlService.language == 'KO'
                              ? '₩'
                              : threeGraphqlService.language == 'EN'
                                ? '$'
                                : '¥') +
                              ' ' +
                              (partModel.marketplaceProduct?.price
                                | currencyConvert: threeGraphqlService.language
                                | money)
                          }}
                        </p>
                      }
                      @if (
                        isViewCompany &&
                        partModel.marketplaceProduct &&
                        partModel.marketplaceProduct.channel
                      ) {
                        <p
                          class="pt-[1px] text-[10px] lg:text-base text-[#807F7B] dark:text-[#7F8084] flex-none flex items-center"
                        >
                          {{ partModel.marketplaceProduct.channel.split('-')[0] }}
                        </p>
                      }
                    </div>
                    <!-- <div class="relative w-full flex flex-row gap-1.5">
                      <button
                        class="w-full py-0.5 lg:py-1 rounded-full"
                        [ngClass]="{
                          'bg-slate-400 ': isLoading,
                          'bg-red-700 hover:bg-red-700/80 active:bg-red-700/90':
                            partModel.isSelected,
                          'bg-white hover:bg-white/80 active:bg-white/90': !partModel.isSelected,
                        }"
                        (click)="onClickPart(partModel)"
                        [disabled]="isLoading"
                      >
                        <p
                          class="text-[10px] lg:text-sm font-semibold"
                          [ngClass]="{
                            'text-white ': partModel.isSelected,
                            'text-black ': !partModel.isSelected,
                          }"
                        >
                          {{
                            isLoading ? 'Loading...' : partModel.isSelected ? 'Delete' : 'Preview'
                          }}
                        </p>
                      </button>
                      <button
                        class="w-full py-0.5 lg:py-1 bg-slate-700 rounded-full text-black disabled:opacity-50"
                        [ngClass]="{
                          'hover:bg-slate-700/80 active:bg-slate-700/90':
                            partModel.marketplaceProduct?.variantId,
                        }"
                        [disabled]="!partModel.marketplaceProduct?.variantId"
                        (click)="onClickAddCart(partModel)"
                      >
                        <p class="text-[10px] lg:text-sm font-semibold text-white">
                          {{
                            partModel.marketplaceProduct?.variantId ? 'Add to Cart' : 'coming soon'
                          }}
                        </p>
                      </button>
                    </div> -->
                  </div>
                  <button
                    class="relative w-1/6 h-full flex justify-center items-center rounded-r-lg bg-[#E3E4E1] dark:bg-[#1C1B1E] group"
                    (click)="onClickPart(partModel)"
                    [disabled]="isLoading"
                  >
                    <div
                      class="flex justify-center items-center text-4xl lg:text-5xl transition-all transform duration-150 ease-in-out group-hover:scale-110 group-active:scale-105"
                      [ngClass]="{
                        'text-red-600 ': partModel.isSelected,
                        'text-black dark:text-white ': !partModel.isSelected,
                      }"
                    >
                      @if (partModel.isSelected) {
                        <mat-icon [inline]="true">do_not_disturb_on</mat-icon>
                      } @else {
                        <mat-icon [inline]="true">add_circle</mat-icon>
                      }
                    </div>
                  </button>
                </div>
              </div>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </mat-tab>
    }
  </mat-tab-group>
</div>
